module.exports = __webpack_public_path__ + "img/img_left_nav_bonus_hover.fdaf29a7.svg";